/* 🌸 Pink Shop 2026 — comportamiento de la tarjeta (6-oct-2026).
   1) Puntitos que siguen al deslizar las fotos.  2) Bolitas de color: tocar una cambia la foto, el
   nombre y la liga de la tarjeta sin salir del catálogo.  3) Corazón de favoritos (localStorage).
   4) Franja de filtros: pestañas que abren su panel. Todo sin librerías. */
(function () {
  function favs() { try { return JSON.parse(localStorage.getItem('ps_favs') || '[]'); } catch (e) { return []; } }
  function setFavs(a) { try { localStorage.setItem('ps_favs', JSON.stringify(a)); } catch (e) {} }

  function armar(card) {
    if (card.dataset.ok) return; card.dataset.ok = '1';
    var slider = card.querySelector('[data-slider]');
    var dots = card.querySelectorAll('.ps-card__dots i');
    if (slider && dots.length) {
      var t; slider.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(function () {
          var i = Math.round(slider.scrollLeft / slider.clientWidth);
          dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        }, 60);
      }, { passive: true });
    }
    var add = card.querySelector('[data-add]');
    if (add) add.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); hoja(card, add); });
    var fav = card.querySelector('[data-fav]');
    if (fav) {
      if (favs().indexOf(fav.dataset.fav) >= 0) fav.classList.add('on');
      fav.addEventListener('click', function (e) {
        e.preventDefault(); var a = favs(), h = fav.dataset.fav, i = a.indexOf(h);
        if (i >= 0) a.splice(i, 1); else a.push(h);
        setFavs(a); fav.classList.toggle('on', i < 0);
      });
    }
    card.querySelectorAll('[data-color]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        card.querySelectorAll('[data-color]').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var url = '/products/' + b.dataset.handle;
        card.dataset.handle = b.dataset.handle;
        card.querySelectorAll('a').forEach(function (a) { a.href = url; });
        var first = card.querySelector('.ps-card__slide img');
        if (first && b.dataset.img) { first.srcset = ''; first.sizes = ''; first.src = b.dataset.img; }
        if (slider) slider.scrollTo({ left: 0 });
        var tt = card.querySelector('.ps-card__title');
        if (tt && b.dataset.colorName) { tt.textContent = tt.textContent.replace(/\s*[—|-]\s*[^—|-]+$/, '') + ' — ' + b.dataset.colorName; }
        // la tarjeta ya apunta al otro color; al segundo toque entra al producto
        if (fav) fav.dataset.fav = b.dataset.handle;
      });
    });
  }

  // 🛍 agregar a la bolsa desde la tarjeta: hoja de tallas abajo (como Fashion Nova)
  var sheet;
  function hoja(card, btn) {
    var vs = []; try { vs = JSON.parse(btn.dataset.variants); } catch (e) {}
    if (!vs.length) { location.href = card.dataset.url; return; }
    if (!sheet) {
      sheet = document.createElement('div'); sheet.className = 'ps-sheet';
      sheet.innerHTML = '<div class="ps-sheet__bg"></div><div class="ps-sheet__box"><div class="ps-sheet__head"><b>SELECCIONA UNA TALLA</b><button type="button" aria-label="Cerrar">×</button></div><div class="ps-sheet__sub"></div><div class="ps-sheet__tallas"></div><div class="ps-sheet__cambio">↔ ¿Compras en línea y no te queda? Cámbiala en tienda dentro de 7 días</div></div>';
      document.body.appendChild(sheet);
      sheet.querySelector('.ps-sheet__bg').addEventListener('click', cerrar); sheet.querySelector('.ps-sheet__head button').addEventListener('click', cerrar);
    }
    sheet.querySelector('.ps-sheet__sub').textContent = btn.dataset.title || '';
    var box = sheet.querySelector('.ps-sheet__tallas'); box.innerHTML = '';
    vs.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = v.t; b.disabled = !v.ok;
      b.addEventListener('click', function () { agregar(v.id, btn); });
      box.appendChild(b);
    });
    sheet.classList.add('on');
  }
  function cerrar() { if (sheet) sheet.classList.remove('on'); }

  // ✅ "Añadido a la bolsa" (Fashion Nova): hoja abajo con el artículo y "Ver bolsa (n)"
  function anadido(item, count) {
    var old = document.querySelector('.ps-added'); if (old) old.remove();
    var s = document.createElement('div'); s.className = 'ps-sheet ps-added on';
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x213$1$2') : '';
    s.innerHTML = '<div class="ps-sheet__bg"></div><div class="ps-sheet__box"><div class="ps-sheet__head"><b>✓ AÑADIDO A LA BOLSA</b><button type="button" aria-label="Cerrar">×</button></div>'
      + '<div class="ps-added__item">' + (img ? '<img src="' + img + '" alt="">' : '') + '<div><div class="ps-added__t">' + (item.product_title || '') + '</div><div class="ps-added__p">' + (item.price != null ? '$' + Math.round(item.price / 100).toLocaleString('es-MX') : '') + '</div><div class="ps-added__v">' + (item.variant_title ? 'Talla: ' + item.variant_title : '') + '</div></div></div>'
      + '<a class="ps-added__btn" href="/cart">Ver bolsa (' + count + ')</a><button type="button" class="ps-added__seguir">Seguir comprando</button>'
      + '<div class="ps-sheet__cambio">↔ ¿Compras en línea y no te queda? Cámbiala en tienda dentro de 7 días</div></div>';
    document.body.appendChild(s);
    var cerrarA = function () { s.remove(); };
    s.querySelector('.ps-sheet__bg').addEventListener('click', cerrarA); s.querySelector('.ps-sheet__head button').addEventListener('click', cerrarA); s.querySelector('.ps-added__seguir').addEventListener('click', cerrarA);
  }
  function toast(html) {
    var t = document.createElement('div'); t.className = 'ps-toast'; t.innerHTML = html; document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3500);
  }
  function agregar(id, btn) {
    btn.classList.add('busy'); cerrar();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        btn.classList.remove('busy');
        if (d && d.status) { toast('No se pudo agregar: ' + (d.description || '')); return; }
        var it = (d.items && d.items[0]) || d; fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { anadido(it, c.item_count); }).catch(function () { anadido(it, 1); });
        // actualizar el contador de la bolsa del tema (Dawn)
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var bub = document.querySelector('.cart-count-bubble span[aria-hidden]'); if (bub) bub.textContent = c.item_count;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }).catch(function () {});
      }).catch(function () { btn.classList.remove('busy'); toast('Sin conexión, inténtalo de nuevo'); });
  }

  function armarFiltros(root) {
    root.querySelectorAll('.ps-filtros__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var k = tab.dataset.panel, abierto = tab.classList.contains('on');
        root.querySelectorAll('.ps-filtros__tab').forEach(function (x) { x.classList.remove('on'); });
        root.querySelectorAll('.ps-filtros__panel').forEach(function (x) { x.classList.remove('on'); });
        if (!abierto) { tab.classList.add('on'); var p = root.querySelector('.ps-filtros__panel[data-panel="' + k + '"]'); if (p) p.classList.add('on'); }
      });
    });
  }

  function init() {
    document.querySelectorAll('.ps-card').forEach(armar);
    document.querySelectorAll('.ps-filtros').forEach(armarFiltros);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
